import React, { useContext, useEffect } from 'react';
import { Context } from '../context/SharedState';

export default function MotoMateModal() {
    const states = useContext(Context);

    useEffect(() => {
        const timer = setTimeout(() => {
            const modalEl = document.getElementById('motoMateModal');
            if (modalEl) {
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();
            }
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    const handleCloseModal = () => {
        const modalEl = document.getElementById('motoMateModal');
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal?.hide();
    };

    // const features = [
    //     'Service Tracking',
    //     'Mileage Logs',
    //     'Fuel Records',
    //     'Parts Management',
    //     'Reminders',
    //     'Much More!'
    // ];
    const features = [
        'Track complete bike service history with dates, costs, and workshop details',
        'Monitor real-time mileage trends to understand bike performance better',
        'Maintain detailed fuel logs for better fuel efficiency analysis',
        'Manage replaced parts history including brand and service notes',
        'Get timely maintenance reminders so you never miss servicing',
        'All-in-one dashboard for complete bike ownership tracking',
    ];

    return (
        <div
            className="modal fade"
            id="motoMateModal"
            aria-hidden="true"
            data-bs-theme={states.mode === 'dark' ? 'dark' : 'light'}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className={`modal-content ${states.mode === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>

                    {/* HEADER */}
                    <div className="modal-header">
                        <div className="d-flex align-items-center">
                            <img
                                src="https://i.ibb.co/KpbfMVZv/Feature-graphic.jpg"
                                alt="MotoMate"
                                style={{ height: 28 }}
                                className="me-2"
                            />
                            <h5 className="mb-0">Discover MotoMate App!</h5>
                        </div>

                        <button
                            className="btn-close"
                            data-bs-dismiss="modal"
                            onClick={handleCloseModal}
                        />
                    </div>

                    {/* BODY */}
                    <div className="modal-body">

                        <h5 className="text-center mb-4">
                            Your Ultimate Bike Companion
                        </h5>

                        <div className="row g-4">

                            {/* LEFT SIDE */}
                            <div className="col-12 col-md-5 text-center">

                                <img
                                    src="https://i.ibb.co/rKYh8TCX/motomate-v2-small.jpg"
                                    className="img-fluid rounded mb-3"
                                    style={{ maxWidth: 180 }}
                                    alt="MotoMate"
                                />

                                <div className="d-grid gap-2">

                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.anonymous.MotoMate"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-success btn-sm"
                                    >
                                        Get from Play Store
                                    </a>

                                    <a
                                        href="https://github.com/NSugam/motomate-v2-backend"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-warning btn-sm"
                                    >
                                        Github Repo
                                    </a>

                                    <button
                                        className={`btn btn-outline-${states.mode === 'dark' ? 'light' : 'secondary'} btn-sm`}
                                        data-bs-dismiss="modal"
                                        onClick={handleCloseModal}
                                    >
                                        Maybe Later
                                    </button>

                                </div>
                            </div>

                            {/* RIGHT SIDE */}
                            <div className="col-12 col-md-7">

                                <p className="mb-3">
                                    Track service records, mileage, parts, fuel logs, and more in one place.
                                </p>

                                <div className="mb-3">
                                    {features.map((item, i) => (
                                        <div key={i} className="d-flex align-items-center mb-2">
                                            <span className="material-symbols-outlined text-success me-2">
                                                check_circle
                                            </span>
                                            <small>{item}</small>
                                        </div>
                                    ))}
                                </div>

                                <div className="alert alert-info mb-0">
                                    <small>
                                        <strong>Available on Play Store</strong><br />
                                        Join riders simplifying bike maintenance.
                                    </small>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}